import { h, Component } from "preact";
import { trackLinkOut } from "utils/tracking";
import { sortObjectByOrder, joinClasses } from "utils/utils";
import { updateDataLayer } from 'utils/tracking';
import { Link } from 'components/core/link/link';
import s from "components/shared/follow/follow.sss";
import Store from "store/store";
import * as actions from "store/actions";

export default class Follow extends Component {
	clickHandler(trackId, link) {
		Store.emit(actions.CLICKED_FOLLOW, trackId, link);
	}

	socialSvgContent(service) {
		switch(service) {
			case 'youtube':
				return (
					<svg class={s.svgYoutube} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
						viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;">
						<path d="M490.24,113.92c-13.888-24.704-28.96-29.248-59.648-30.976C399.936,80.864,322.848,80,256.064,80
						c-66.912,0-144.032,0.864-174.656,2.912c-30.624,1.76-45.728,6.272-59.744,31.008C7.36,138.592,0,181.088,0,255.904
						C0,255.968,0,256,0,256c0,0.064,0,0.096,0,0.096v0.064c0,74.496,7.36,117.312,21.664,141.728
						c14.016,24.704,29.088,29.184,59.712,31.264C112.032,430.944,189.152,432,256.064,432c66.784,0,143.872-1.056,174.56-2.816
						c30.688-2.08,45.76-6.56,59.648-31.264C504.704,373.504,512,330.688,512,256.192c0,0,0-0.096,0-0.16c0,0,0-0.064,0-0.096
						C512,181.088,504.704,138.592,490.24,113.92z M192,352V160l160,96L192,352z"/>
					</svg>
				);
			case 'facebook':
				return (
					<svg class={s.svgFacebook} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
						<path class="st0" d="M8,0C3.582,0,0,3.582,0,8c0,3.929,2.835,7.19,6.57,7.865V10.07H4.503V7.759H6.57V6.055
							C6.57,4.077,7.822,3,9.65,3c0.875,0,1.628,0.063,1.847,0.091v2.067l-1.268,0.001c-0.995,0-1.186,0.456-1.186,1.126V7.76h2.37
							l-0.309,2.311H9.042v5.854C12.967,15.413,16,12.064,16,8C16,3.582,12.418,0,8,0z"/>
					</svg>
				);
			case 'instagram':
				return (
					<svg class={s.svgInstagram} viewBox="1 1 13 13" xmlns="http://www.w3.org/2000/svg">
						<g transform="translate(7.000000, 7.000000)">
							<path
								class="st0"
								d="M1-5C-0.63-5-0.834-4.993-1.474-4.964C-2.112-4.935-2.549-4.833-2.93-4.685
								c-0.395,0.153-0.729,0.358-1.063,0.692C-4.327-3.659-4.532-3.325-4.685-2.93c-0.148,0.382-0.25,0.818-0.279,1.456
								C-4.993-0.834-5-0.63-5,1s0.007,1.834,0.036,2.474c0.029,0.639,0.131,1.075,0.279,1.456c0.153,0.395,0.358,0.729,0.692,1.063
								c0.334,0.334,0.668,0.539,1.063,0.692c0.382,0.148,0.818,0.25,1.456,0.279C-0.834,6.993-0.63,7,1,7
								c1.63,0,1.834-0.007,2.474-0.036C4.112,6.935,4.549,6.833,4.93,6.685c0.395-0.153,0.729-0.358,1.063-0.692
								C6.327,5.659,6.532,5.325,6.685,4.93c0.148-0.382,0.25-0.818,0.279-1.456C6.993,2.834,7,2.63,7,1C7-0.63,6.993-0.834,6.964-1.474
								C6.935-2.112,6.833-2.549,6.685-2.93C6.532-3.325,6.327-3.659,5.993-3.993C5.659-4.327,5.325-4.532,4.93-4.685
								c-0.382-0.148-0.818-0.25-1.456-0.279C2.834-4.993,2.63-5,1-5 M1-3.919c1.602,0,1.792,0.006,2.425,0.035
								C4.009-3.857,4.327-3.76,4.539-3.677c0.28,0.109,0.48,0.239,0.69,0.449c0.21,0.21,0.34,0.41,0.449,0.69
								c0.082,0.211,0.18,0.529,0.207,1.114C5.913-0.792,5.919-0.602,5.919,1c0,1.602-0.006,1.792-0.035,2.425
								C5.857,4.01,5.759,4.327,5.677,4.539c-0.109,0.28-0.239,0.48-0.449,0.69c-0.21,0.21-0.41,0.34-0.69,0.449
								c-0.211,0.082-0.529,0.18-1.114,0.207C2.792,5.913,2.602,5.919,1,5.919s-1.792-0.006-2.425-0.035
								C-2.01,5.857-2.327,5.759-2.539,5.677c-0.28-0.109-0.48-0.239-0.69-0.449c-0.21-0.21-0.34-0.41-0.449-0.69
								C-3.76,4.327-3.857,4.01-3.884,3.425C-3.913,2.792-3.919,2.602-3.919,1c0-1.602,0.006-1.792,0.035-2.425
								C-3.857-2.01-3.76-2.327-3.677-2.539c0.109-0.28,0.239-0.48,0.449-0.69c0.21-0.21,0.41-0.34,0.69-0.449
								c0.211-0.082,0.529-0.18,1.114-0.207C-0.792-3.913-0.602-3.919,1-3.919"
							/>
							<path
								class="st0"
								d="M0.986,2.982c-1.102,0-1.995-0.893-1.995-1.995s0.893-1.995,1.995-1.995s1.995,0.893,1.995,1.995
								S2.088,2.982,0.986,2.982 M0.986-2.088c-1.698,0-3.074,1.376-3.074,3.074c0,1.698,1.376,3.074,3.074,3.074S4.06,2.684,4.06,0.986
								C4.06-0.712,2.684-2.088,0.986-2.088"
							/>
							<path
								class="st0"
								d="M4.182-1.491c-0.397,0-0.718-0.322-0.718-0.718s0.322-0.718,0.718-0.718
								c0.397,0,0.718,0.322,0.718,0.718S4.578-1.491,4.182-1.491z"
							/>
						</g>
					</svg>
				);
			case 'tiktok':
				return (
					<svg viewBox="-32 0 512 512" xmlns="http://www.w3.org/2000/svg">
						<path d="m432.734375 112.464844c-53.742187 0-97.464844-43.722656-97.464844-97.464844 0-8.285156-6.71875-15-15-15h-80.335937c-8.285156 0-15 6.714844-15 15v329.367188c0 31.59375-25.703125 57.296874-57.300782 57.296874-31.59375 0-57.296874-25.703124-57.296874-57.296874 0-31.597657 25.703124-57.300782 57.296874-57.300782 8.285157 0 15-6.714844 15-15v-80.335937c0-8.28125-6.714843-15-15-15-92.433593 0-167.632812 75.203125-167.632812 167.636719 0 92.433593 75.199219 167.632812 167.632812 167.632812 92.433594 0 167.636719-75.199219 167.636719-167.632812v-145.792969c29.855469 15.917969 63.074219 24.226562 97.464844 24.226562 8.285156 0 15-6.714843 15-15v-80.335937c0-8.28125-6.714844-15-15-15zm-15 79.714844c-32.023437-2.664063-62.433594-13.851563-88.707031-32.75-4.566406-3.289063-10.589844-3.742188-15.601563-1.171876-5.007812 2.5625-8.15625 7.71875-8.15625 13.347657v172.761719c0 75.890624-61.746093 137.632812-137.636719 137.632812-75.890624 0-137.632812-61.742188-137.632812-137.632812 0-70.824219 53.773438-129.328126 122.632812-136.824219v50.8125c-41.015624 7.132812-72.296874 42.984375-72.296874 86.011719 0 48.136718 39.160156 87.300781 87.296874 87.300781 48.140626 0 87.300782-39.164063 87.300782-87.300781v-314.367188h51.210937c6.871094 58.320312 53.269531 104.71875 111.589844 111.589844zm0 0"/></svg>
				);
			case 'twitter':
				return (
					<svg class={s.svgTwitter} viewBox="1 2 13 12" xmlns="http://www.w3.org/2000/svg">
						<path class="st0" d="M5.774,12.876c4.528,0,7.005-3.752,7.005-7.005c0-0.107-0.002-0.213-0.007-0.318
							C13.252,5.206,13.67,4.772,14,4.278c-0.441,0.196-0.916,0.328-1.414,0.388c0.508-0.305,0.899-0.787,1.083-1.362
							c-0.476,0.282-1.002,0.487-1.563,0.598c-0.449-0.479-1.089-0.778-1.797-0.778c-1.36,0-2.462,1.103-2.462,2.462
							c0,0.193,0.022,0.381,0.064,0.561C5.864,6.044,4.049,5.064,2.835,3.575C2.624,3.938,2.502,4.361,2.502,4.812
							c0,0.854,0.435,1.608,1.096,2.049C3.194,6.849,2.814,6.738,2.482,6.553c-0.001,0.01-0.001,0.021-0.001,0.031
							c0,1.193,0.849,2.188,1.975,2.414C4.25,9.055,4.033,9.085,3.808,9.085c-0.159,0-0.313-0.016-0.463-0.044
							c0.313,0.978,1.222,1.69,2.3,1.71c-0.843,0.66-1.904,1.054-3.058,1.054c-0.199,0-0.395-0.011-0.587-0.034
							C3.09,12.469,4.383,12.876,5.774,12.876"
						/>
					</svg>
				);
			case 'imdb':
				return (
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"/>
					</svg>

				);
			case 'vk':
				return (
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
						<g transform="translate(128 128) scale(0.72 0.72)" style="">
							<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)" >
								<path d="M 87.935 21.894 c 0.626 -2.086 0 -3.619 -2.977 -3.619 h -9.846 c -2.504 0 -3.658 1.324 -4.283 2.785 c 0 0 -5.008 12.204 -12.101 20.132 c -2.294 2.295 -3.337 3.026 -4.59 3.026 c -0.625 0 -1.531 -0.731 -1.531 -2.816 V 21.894 c 0 -2.503 -0.727 -3.619 -2.813 -3.619 H 34.32 c -1.564 0 -2.506 1.162 -2.506 2.264 c 0 2.373 3.547 2.921 3.913 9.597 v 14.499 c 0 3.179 -0.574 3.757 -1.826 3.757 c -3.337 0 -11.457 -12.26 -16.273 -26.288 c -0.944 -2.727 -1.89 -3.828 -4.406 -3.828 H 3.376 C 0.562 18.275 0 19.599 0 21.059 c 0 2.608 3.337 15.543 15.542 32.65 c 8.136 11.682 19.599 18.016 30.031 18.016 c 6.258 0 7.033 -1.407 7.033 -3.83 v -8.829 c 0 -2.814 0.593 -3.375 2.575 -3.375 c 1.46 0 3.963 0.729 9.805 6.362 c 6.676 6.676 7.776 9.671 11.532 9.671 h 9.846 c 2.812 0 4.219 -1.407 3.408 -4.182 c -0.889 -2.767 -4.076 -6.781 -8.305 -11.538 c -2.295 -2.712 -5.738 -5.633 -6.781 -7.094 c -1.461 -1.877 -1.043 -2.711 0 -4.381 C 74.687 44.53 86.684 27.631 87.935 21.894" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: evenodd; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
							</g>
						</g>
					</svg>
				);
		}

	}

	render(props) {

		const {
			followClass  = "",     // (string) class to be applied to component wrapper
			followData   = {},     // (object) containing tracking Ids and copy refs for social links
			socialData   = {},     // (object) containing urls for social links
			copy         = {},     // (object) appData copy object
			iconShade    = "light", // (string) whether to use white or black icons
			color		 = ""
		} = props;

		// FollowData is the data that comes specifically from the parent
		// Social data is the data that comes from meta and is more for the whole app (can be used for links for example)
		if (followData) {
			// Lets sort them if there is an order
			const follow = sortObjectByOrder(followData, (f, key) => {
				let link = f.link;
				// If the link doesn't exist in the normal object. lets see if they added it to the global one
				if (
					!link &&
					socialData &&
					socialData[key] &&
					socialData[key].link
				) {
					link = socialData[key].link;
				}

				let text = "";
				if (copy && followData[key]) {
					const copyKey = followData[key].$copy;
					text = copy[copyKey] || "";
				}

				const useDarkIcon = iconShade == "dark";

				const platformName = key[0].toUpperCase() + key.substring(1);
				const ariaLabel = (copy.$ARIALABEL_FOLLOW_ON_PLATFORM || '') + (copy.$ARIALABEL_FOLLOW_ON_PLATFORM && ' ') + platformName + (copy.$ARIALABEL_FOLLOW_ON_PLATFORM_AFTER && ' ') + (copy.$ARIALABEL_FOLLOW_ON_PLATFORM_AFTER || '');

				if (color) {
					return (
						// f.trackId is switched to be label because we need track action to be 'social-follow'
						<li class={s.followWrapper}>
							<Link
								ref={e => this.$link = e}
								href={link}
								linkClass={joinClasses(
									s.icon,
									s["svgLink-" + key]
								)}
								extraOnClick={this.clickHandler.bind(true, key, link)}
								target={key !== "email" ? "_blank" : ""}
								trackId={f.trackId}
								trackLabel={"social-follow"}
								renderCustomChild
								ariaLabel={ariaLabel}
							>
								{text}
								{this.socialSvgContent(key)}
							</Link>
						</li>
					);
				}
				return (
					// f.trackId is switched to be label because we need track action to be 'social-follow'
					<li class={s.followWrapper}>
						<Link
							ref={e => this.$link = e}
							href={link}
							linkClass={joinClasses(
								s.icon,
								useDarkIcon && s.dark,
								s["icon-" + key]
							)}
							extraOnClick={this.clickHandler.bind(true, key, link)}
							target={key !== "email" ? "_blank" : ""}
							trackId={f.trackId}
							trackLabel={"social-follow"}
							renderCustomChild
							ariaLabel={ariaLabel}
						>
							{text}
						</Link>
					</li>
				);

			});

			const followCta = copy && copy.$FOLLOW_CTA;

			return (
				<div class={followClass}>
					<ul class={s.followContainer}>
						{followCta && <span class={s.followCta}>{followCta}</span>}
						{follow}
					</ul>
				</div>
			);
		} else {
			return <div />;
		}
	}
}
